import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVerticalAlignmentCenter"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3V6H20V11H13V13H18V18H13V21H11V18H6V13H11V11H4V6H11V3H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVerticalAlignmentCenter;
